import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import breakpoint from 'styled-components-breakpoint';

import theme from '@theme';

export const StyledUpload = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 40px;
  outline: none;
`;

export const StyledUploadParagraph = styled.p`
  margin: ${props => (props.treatmentFormName || props.isModal ? '0 0' : '20px 0')};
  font-weight: 600;
  font-size: ${props => (props.treatmentFormName || props.isModal ? '18px' : '22px')};
  max-width: 500px;
  min-height: 50px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.navyGray};

  b {
    font-weight: 600;
  }

  ${breakpoint('mobile', 'desktop')`
    font-size: ${props => (props.treatmentFormName || props.isModal ? '16px' : '18px')};
    margin: ${props => props.treatmentFormName && '10px 0'};
    ${props => props.isModal && 'margin-bottom: 10px'}
  `}
`;

export const StyledUploadSpan = styled.span`
  font-weight: 600;
  font-size: ${props => (props.treatmentFormName || props.isModal ? '18px' : '22px')};
  text-align: center;
  color: ${theme.colors.seagulBlue};

  ${breakpoint('mobile', 'desktop')`
    font-size: ${props => (props.treatmentFormName || props.isModal ? '16px' : '18px')};
  `}
`;

export const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  font-size: 72px;
  height: ${props => (props.isModal ? '62px' : '72px')};

  transition: all 0.5s ease;
  svg {
    width: 100%;
  }
  svg,
  path {
    fill: ${theme.colors.gray};
    stroke: ${theme.colors.gray};
  }

  &.active {
    svg,
    path {
      fill: ${theme.colors.defaultGreen};
      stroke: ${theme.colors.defaultGreen};
    }
  }
`;
